module.exports = __webpack_public_path__ + "img/icon_q.06db560d.svg";